import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "../../apis/EdisonApi";
import Loader from "../common/Loader";

const applianceNames = {
	washerdryer1: "Washer-dryer",
	smartplug1: "Smart plug",
	netatmo1: "Thermostat",
};

const formatEventValue = (value) => {
	if (value === true) return "ON";
	if (value === false) return "OFF";
	return String(value ?? "—");
};

const EventsList = () => {
	const [events, setEvents] = useState(null);

	useEffect(() => {
		const controller = new AbortController();

		api.get("/home/last-events", { signal: controller.signal })
			.then((response) => {
				setEvents(Array.isArray(response.data) ? response.data.slice(0, 5) : []);
			})
			.catch((error) => {
				if (error.name !== "CanceledError") {
					toast.error("API error getting last events");
				}
			});

		return () => controller.abort();
	}, []);

	return (
		<section className="x_panel" aria-labelledby="events-title">
			<div className="x_title">
				<h2 id="events-title">Latest events</h2>
				<div className="clearfix" />
			</div>
			<div className="x_content">
				{events === null && (
					<div className="panel-empty" role="status">
						<Loader size={28} />
						<span>Loading events…</span>
					</div>
				)}

				{events?.length === 0 && (
					<p className="panel-empty">No recent events are available.</p>
				)}

				{events?.length > 0 && (
					<ul className="event-list">
						{events.map((event, index) => (
							<li key={`${event.app || "event"}-${event.dt || index}-${index}`}>
								<span className="event-list__device">
									{applianceNames[event.app] || event.app || "Device"}
								</span>
								<div className="event-list__details">
									<strong>{formatEventValue(event.state)}</strong>
									<time>{event.dt || "Time not available"}</time>
								</div>
							</li>
						))}
					</ul>
				)}
			</div>
		</section>
	);
};

export default EventsList;
